"use strict";

exports.__esModule = true;
exports.HUMAN = exports.ERROR = exports.ASSISTANT = exports.AIChatContext = void 0;
var _react = require("react");
var _Utils = require("../../../Utils");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _Core = require("../../Core");
var HUMAN = exports.HUMAN = "human";
var ASSISTANT = exports.ASSISTANT = "assistant";
var ERROR = exports.ERROR = "error";
var AIChatController = function AIChatController(_ref) {
  var children = _ref.children;
  var dataAccessor = (0, _react.useContext)(_DataAccessorContext.DataAccessorContext);
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useState = (0, _react.useState)([]),
    messages = _useState[0],
    setMessages = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var sendMessage = function sendMessage(message) {
    setIsLoading(true);
    dataAccessor.sendAIChatMessage([].concat(messages.toReversed(), [[HUMAN, message]])).then(function (res) {
      setMessages(function (prevMessages) {
        var newMessages = [].concat(prevMessages);
        newMessages[0].push(res.prompt);
        return [[ASSISTANT, res.message]].concat(newMessages);
      });
      setIsLoading(false);
    })["catch"](function () {
      setMessages(function (prevMessages) {
        return [[ERROR, translate("AIChatDialog.Error", "Service is currently unavailable. Please check back soon.")]].concat(prevMessages);
      });
      setIsLoading(false);
    });
    setMessages(function (prevMessages) {
      return [[HUMAN, message]].concat(prevMessages);
    });
  };
  return children({
    messages: messages,
    sendMessage: sendMessage,
    isLoading: isLoading
  });
};
var AIChatContext = exports.AIChatContext = (0, _Utils.createEnhancedContext)({
  propName: "aiChatContext",
  defaultController: AIChatController
});